import React from 'react';
import CopyLinkToClipboard from "./CopyLinkToClipboard";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {Box, Button, useTheme} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {registerPushSW} from '../utils'
import {addSubscription} from '../api'
import { ADD_NOTIFICATION } from "../store/action";

const PersonalDetails = ({shortHash, dispatch, supplierId}) => {
    const theme = useTheme()
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'))
    const {t} = useTranslation()

    return <div style={{width: isDesktop ? theme.maxContentWidth : '100%'}}>
        <CopyLinkToClipboard shortHash={shortHash}/>
        <Box pt={2} display={'flex'} justifyContent={'center'}>
            <Button variant={'outlined'} color={'primary'} onClick={() => {
                registerPushSW().then((subscription) => {
                    addSubscription({supplierId, subscription}).then(({data: {success}}) => {
                        if (success) {
                            dispatch({
                                type: ADD_NOTIFICATION,
                                payload: {
                                    type: 'success',
                                    text: t('device_added_successfully')
                                }
                            })
                        } else {
                            throw new Error()
                        }
                    }).catch(() => {
                        throw new Error()
                    })
                }).catch(() => {
                    dispatch({
                        type: ADD_NOTIFICATION,
                        payload: {
                            type: 'error',
                            text: t('cant_subscribe_to_notifications')
                        }
                    })
                })
            }}>{t('get_notifications_on_this_device')}</Button>
        </Box>
        <Box pt={5} display={'flex'} justifyContent={'center'}>
            <Link to={'/edit-supplier'}>
                <Button variant='outlined' color={'primary'}>
                    {t('edit_details')}
                </Button>
            </Link>
        </Box>
        {/*<Box pt={5} display={'flex'} justifyContent={'center'}>*/}
        {/*    <Link to={'/pay'}>*/}
        {/*        <Button variant='outlined' color={'primary'}>*/}
        {/*            {t('pay')}*/}
        {/*        </Button>*/}
        {/*    </Link>*/}
        {/*</Box>*/}
    </div>
}
const mapStateToProps = state => ({
    shortHash: state.general?.supplier?.personalData?.shortHash,
    supplierId: state.general.supplier?.personalData?._id,
})
export default connect(mapStateToProps)(PersonalDetails);